import request from '@/router/axios'

export function getTagList(query) {
  return request({
    url: '/basic/tag',
    method: 'get',
    params: query
  })
}

export function getTagListByTag(query) {
  return request({
    url: '/basic/admin/tag/tag-prop',
    method: 'get',
    params: query
  })
}